export const SYS_NAME = `CLIENTS_SUBSYSTEM`;

export const START = `${SYS_NAME}:START`;
export const STARTED = `${SYS_NAME}:STARTED`;
export const STOP = `${SYS_NAME}:STOP`;
export const STOPPED = `${SYS_NAME}:STOPPED`;
export const CLEAR = `${SYS_NAME}:CLEAR`;

export const ADD_CLIENT = `${SYS_NAME}:ADD_CLIENT`;
export const REMOVE_CLIENT = `${SYS_NAME}:REMOVE_CLIENT`;
export const SELECT_CLIENT = `${SYS_NAME}:SELECT_CLIENT`;
export const DESELECT_CLIENT = `${SYS_NAME}:DESELECT_CLIENT`;
export const ACCEPT_INCOMING_CALL = `${SYS_NAME}:ACCEPT_INCOMING_CALL`;
export const MUTE_INCOMING_CALL = `${SYS_NAME}:DECLINE_INCOMING_CALL`;
export const CLEAR_ONGOING_CALL = `${SYS_NAME}:CLEAR_ONGOING_CALL`;
export const SET_PRIVILEGES = `${SYS_NAME}:SET_PRIVILEGES`;

export const TOGGLE_OKTELL_SYNC = `${SYS_NAME}:TOGGLE_OKTELL_SYNC`;

export const CREATE_SUPPORT_TICKET = `${SYS_NAME}:CREATE_SUPPORT_TICKET`;
export const CLEAR_SUPPORT_TICKET_REQUEST = `${SYS_NAME}:CLEAR_SUPPORT_TICKET_REQUEST`;

export const CREATE_SERVICE_DESK_REQUEST = `${SYS_NAME}:CREATE_SERVICE_DESK_REQUEST`;
export const CREATE_SERVICE_DESK_REQUEST_SUCCESS = `${SYS_NAME}:CREATE_SERVICE_DESK_REQUEST:SUCCESS`;
export const CREATE_SERVICE_DESK_REQUEST_REJECTED = `${SYS_NAME}:CREATE_SERVICE_DESK_REQUEST:REJECTED`;

export const HANDLE_INCOMING_CALL = `${SYS_NAME}:HANDLE_INCOMING_CALL`;
export const HANDLE_INCOMING_CALL_SUCCESS = `${SYS_NAME}:HANDLE_INCOMING_CALL:SUCCESS`;
export const HANDLE_INCOMING_CALL_REJECTED = `${SYS_NAME}:HANDLE_INCOMING_CALL:REJECTED`;

export const START_LISTEN_FOR_CALLS = `${SYS_NAME}:START_LISTEN_FOR_CALLS`;
export const START_LISTEN_FOR_CALLS_SUCCESS = `${SYS_NAME}:START_LISTEN_FOR_CALLS:SUCCESS`;
export const START_LISTEN_FOR_CALLS_REJECTED = `${SYS_NAME}:START_LISTEN_FOR_CALLS:REJECTED`;

export const STOP_LISTEN_FOR_CALLS = `${SYS_NAME}:STOP_LISTEN_FOR_CALLS`;
export const STOP_LISTEN_FOR_CALLS_SUCCESS = `${SYS_NAME}:STOP_LISTEN_FOR_CALLS:SUCCESS`;
export const STOP_LISTEN_FOR_CALLS_REJECTED = `${SYS_NAME}:STOP_LISTEN_FOR_CALLS:REJECTED`;

export const CHECK_NEW_CALLS = `${SYS_NAME}:CHECK_NEW_CALLS`;
export const CHECK_NEW_CALLS_SUCCESS = `${SYS_NAME}:CHECK_NEW_CALLS:SUCCESS`;
export const CHECK_NEW_CALLS_REJECTED = `${SYS_NAME}:CHECK_NEW_CALLS:REJECTED`;

export const SYNC_FOR_NEW_CALLS = `${SYS_NAME}:SYNC_FOR_NEW_CALLS`;
export const SYNC_FOR_NEW_CALLS_ERROR = `${SYS_NAME}:SYNC_FOR_NEW_CALLS:ERROR`;
export const OKTELL_WS_OPENED = `${SYS_NAME}:OKTELL_WS_OPENED`;
export const OKTELL_WS_CLOSED = `${SYS_NAME}:OKTELL_WS_CLOSED`;
export const SEND_WS_MESSAGE = `${SYS_NAME}:SEND_WS_MESSAGE`;
export const OKTELL_WS_ERROR = `${SYS_NAME}:OKTELL_WS:ERROR`;
export const NEW_CALL_DETECTED = `${SYS_NAME}:NEW_CALL_DETECTED`;
export const CALL_FINISHED = `${SYS_NAME}:CALL_FINISHED`;

export const CALL_STATUS_STARTED = `started`;
export const CALL_STATUS_FINISHED = `finished`;



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/CONSTANTS.js